import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  /** When true, link goes directly to the external checkout. Otherwise it scrolls to the #pricing section. */
  checkout?: boolean;
}
export const CHECKOUT_URL = 'https://physio-ready.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  checkout = false
}: CTAButtonProps) {
  const classes = `
    block w-full text-center cursor-pointer
    px-4 py-4 sm:py-5
    font-heading font-bold text-base sm:text-xl uppercase tracking-wide
    rounded-md
    bg-brand-navy text-white
    hover:bg-brand-gold hover:text-brand-navy hover:scale-[1.02]
    transition-all duration-200
    border-b-4 border-brand-navy-dark hover:border-brand-gold-dark active:border-b-0 active:translate-y-1
    shadow-[0_4px_14px_0_rgba(46,74,103,0.35)] hover:shadow-[0_6px_20px_rgba(200,162,74,0.45)]
    ${className}
  `;
  if (checkout) {
    return <a href={CHECKOUT_URL} className={classes} data-id="element-37">
        {children}
      </a>;
  }
  return <a href="#pricing" className={classes} data-id="element-38">
      {children}
    </a>;
}